import { useMemo } from 'react'

/**
 * Fecha de hoy formateada en la zona horaria y el idioma del visitante
 * (derivados de su conexión/dispositivo), p. ej. "martes 16 de septiembre".
 */
export function useTodayLabel(): string {
  return useMemo(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const formatted = new Intl.DateTimeFormat('es-ES', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZone,
    }).format(new Date())
    return formatted.replace(',', '')
  }, [])
}
